/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import Hidden from "@mui/material/Hidden";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormLegend from "../../Common/FormLegend/FormLegend";
import wizardStyle from "../../wizardStyle";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

type WaitingForAiResponseProps = {
  mobileHeadline: string;
  headline: string;
  text: string;
};

export default function WaitingForAiResponse({ mobileHeadline, headline, text }: WaitingForAiResponseProps) {
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <Box sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }}>
        <Hidden smUp>
          <Typography variant={"h4"} sx={wizardStyle.headline}>
            {mobileHeadline}
          </Typography>
        </Hidden>
        <Grid container justifyContent={"flex-start"} alignItems={"baseline"}>
          <Grid item xs={12}>
            <FormLegend>
              <strong>{headline}</strong>
            </FormLegend>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3} py={10}>
              <CircularProgress size={45} />
              <Typography sx={{ textAlign: "center", mt: 5 }} dangerouslySetInnerHTML={{ __html: text }}></Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
